import { render } from "./MainHirings.vue?vue&type=template&id=4aae7bca&scoped=true"
import script from "./MainHirings.vue?vue&type=script&lang=js"
export * from "./MainHirings.vue?vue&type=script&lang=js"

import "./MainHirings.vue?vue&type=style&index=0&id=4aae7bca&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aae7bca"]])

export default __exports__